import { apiPost } from "../baseApi";
import { setDistrictData } from "service/mapper";

export const create = async (data) => {
  try {
    const response = await apiPost("_district", data);
    return { ...response, data: setDistrictData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
